import { Counter } from '@cad-arc';
import { colors } from '../../colors/colors';

export const NotificationCounter: React.FC<{
    children: number;
    style?: Omit<React.CSSProperties, 'color' | 'backgroundColor'>;
    isUrgent?: boolean;
    button?: string;
}> = ({ children: count, button = '', isUrgent = false, style = {} }) => {
    if (count === 0) {
        return <></>;
    }

    const finalStyle = {
        ...(isUrgent
            ? {
                  backgroundColor: colors.notificationCounterUrgentBackground,
                  color: colors.notificationCounterUrgentText,
              }
            : {
                  backgroundColor: 'var(--arc-colors-warning-default)',
                  color: 'var(--arc-colors-warning-content)',
              }),
        ...style,
    };

    return (
        <Counter
            maxCount={9}
            data-testid={`${button}${isUrgent ? '-urgent' : ''}-counter`}
            style={finalStyle}
        >
            {count}
        </Counter>
    );
};
